<template>
  <div class="home">
    <div class="Tmenu">
      <topMenu></topMenu>
    </div>
    <div class="main">
 <!-- <div class="title">
        <span>海南医学院欢迎你，</span>
      </div> -->
     <div>
        <router-view></router-view>
     </div>
    </div>
      <div class="footer">V1.1</div>

  </div>
</template>
<script>
import topMenu from '@/components/topMenu.vue'
export default {
  components:{
    topMenu,
  },
  
}
</script>
<style scoped>
.home{
  /* background: #F4F5F5; */
  /* height: 100vh; */
}
.Tmenu{
  /* position: fixed; */
  width: 100%;
  top:0px;
  z-index: 100 !important;
}
.main{
  /* margin:20px auto; */
  /* width:1200px; */
  width:100%;
  height: 100vh;
  overflow: auto;
  background: url("../assets/index/indexBackg4.png") no-repeat bottom;
  background-size: 100% auto;
}

.main>div:nth-child(2){
  width: 1200px;
  margin: auto;
  /* background: white; */
  height: 100vh;
  position: relative;
  /* left: 30%; */
}.footer {
  background: #2d76f9;
  height: 30px;
  width: 100%;
  min-width: 1200px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  color: #0095ff;
  text-align: left;
}
.title {
  background: #2d76f926;
  height: 60px;
  width: 320px;
  position: relative;
  top: 0px;
  left: 0px;
  padding: auto;
}
.title::after {
  content: "";
  width: 0;
  height: 0;
  border-bottom: 60px solid #2d76f926;
  /* border-bottom: 80px solid white; */
  border-right: 50px solid transparent;
  position: absolute;
  top: 0px;
  right: -50px;
}
.title span {
  color: white;
  font-weight: 800;
  font-size: 30px;
  line-height: 60px;
  padding-left: 50px;
}
</style>